import React from 'react';
import PropTypes from 'prop-types';
import { Droppable } from 'react-beautiful-dnd';

export default function DroppableWrapper({
  isDragDisabled,
  droppableId,
  type,
  children,
}) {
  if (isDragDisabled) {
    // When drag is disabled, call children with empty props
    return children({
      droppableProps: {},
      innerRef: () => {},
      placeholder: null,
    });
  }

  return (
    <Droppable droppableId={droppableId} type={type}>
      {children}
    </Droppable>
  );
}

DroppableWrapper.propTypes = {
  isDragDisabled: PropTypes.bool,
  droppableId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  children: PropTypes.func.isRequired,
};

DroppableWrapper.defaultProps = {
  isDragDisabled: false,
};

